import {unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {Availability, Record} from 'typings/portaro.be.types';

export default class AvailabilityDataService {
    public static readonly serviceName = 'availabilityDataService'

    private static readonly AVAILABILITY_ROUTE = 'availability';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getByDocumentAndRequester(record: Record, requesterId: number): Promise<Availability> {
        return this.Restangular
                   .one(AvailabilityDataService.AVAILABILITY_ROUTE)
                   .get({
                       document: record.id,
                       requester: requesterId
                   });
    }

    @ngAsync()
    @unRestangularize()
    public async getByExemplarAndRequester(exemplarId: number, requesterId: number): Promise<Availability> {
        return this.Restangular
                   .one(AvailabilityDataService.AVAILABILITY_ROUTE)
                   .get({
                       exemplar: exemplarId,
                       requester: requesterId
                   });
    }
}
